import * as React from 'react'

import Svg, { Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const WorkBagWithColor = ({
  size = 36,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <Rect width={36} height={36} rx={18} fill="#FFFDFB" />
    <Path
      d="M22.922 9.563v1.406c0 .394-.31.703-.703.703h-.703v-2.11a.696.696 0 0 0-.703-.703h-5.625a.696.696 0 0 0-.704.704v2.109h-.703a.696.696 0 0 1-.703-.703V9.563c0-1.168.942-2.11 2.11-2.11h5.624c1.168 0 2.11.942 2.11 2.11Z"
      fill="#62A0DE"
    />
    <Path
      d="M20.813 8.86H18V7.452h2.813c1.167 0 2.109.942 2.109 2.11v1.406c0 .394-.31.703-.703.703h-.703v-2.11a.696.696 0 0 0-.703-.703Z"
      fill="#306EAD"
    />
    <Path
      d="M30 10.969v15.469c0 1.167-.942 2.109-2.11 2.109H8.11A2.107 2.107 0 0 1 6 26.437V10.97a.69.69 0 0 1 .211-.492l3.586 8.071h16.406l3.586-8.071a.69.69 0 0 1 .211.492Z"
      fill="#AFD7FF"
    />
    <Path
      d="M30 10.969v15.469c0 1.167-.942 2.109-2.11 2.109H18v-9.999h8.203l3.586-8.071a.69.69 0 0 1 .211.492Z"
      fill="#6DB6FF"
    />
    <Path
      d="m29.789 10.476-2.18 8.072a2.106 2.106 0 0 1-2.039 1.561H10.43a2.106 2.106 0 0 1-2.04-1.56l-2.18-8.072a.69.69 0 0 1 .493-.211h22.594a.69.69 0 0 1 .492.21Z"
      fill="#7EBFFF"
    />
    <Path
      d="m29.789 10.476-2.18 8.072a2.106 2.106 0 0 1-2.039 1.561H18v-9.843h11.297a.69.69 0 0 1 .492.21Z"
      fill="#389CFF"
    />
    <Path
      d="M20.813 18h-5.625a.696.696 0 0 0-.704.703v2.813c0 .393.31.703.704.703h5.624c.394 0 .704-.31.704-.703v-2.813a.696.696 0 0 0-.703-.703Z"
      fill="#62A1DE"
    />
    <Path
      d="M21.516 18.703v2.813c0 .393-.31.703-.703.703H18V18h2.813c.393 0 .703.31.703.703Z"
      fill="#306EAD"
    />
  </Svg>
)

export default WorkBagWithColor
